// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2hS4b","inputWrap":"CustomTip_inputWrap__1zgzT"};